import type { Int } from "@/types";

import { client } from "@/config/client";

import { ASSET_EVENT_API_URL } from "./constants";

export const fetchAssetEvents = (assetId: Int, params?: object) => {
  return client.axios.get(`assets/${assetId}/${ASSET_EVENT_API_URL}`, {
    params,
  });
};

export const getQueryKey = (
  assetId: Int,
  params?: object,
  isInfinite = false
) => {
  const queryKey = ["assets", assetId, "events", params];
  return isInfinite ? [...queryKey, "infinite"] : queryKey;
};
